define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"csi/widget/MessageDialog"
], function(declare, Controller, MessageDialog) {

	return declare(Controller, {
		getConfirmButton() {
			return MessageDialog.BUTTON_DELETE;
		},

		postProcessSuccess() {
			this.widget.refreshData();
			this.widget.getSiblingView("ExceptionLanguageCompositionStrings")?.refreshData();
		}
	});
});